<template>
  <v-carousel
    v-if="items.length"
    delimiter-icon="stop"
    hide-delimiters
    cycle
    height="180px"
    show-arrows-on-hover
    hide-delimiter-background
    next-icon="fad fa-chevron-right"
    prev-icon="fad fa-chevron-left"
    role="region"
    aria-label="Latest community news carousel"
  >
    <v-carousel-item
      v-for="item in items"
      :key="item.slug"
      :value="item.message"
      :src="item.full_picture"
      :ripple="true"
      class="landing-carsoul-item"
      role="button"
      tabindex="0"
      :aria-label="`${item.title}: ${item.date}`"
      @click="showDialog(item.slug)"
      @keyup.enter="showDialog(item.slug)"
    >
      <v-layout
        class="landing-carsoul-content"
        column
        align-center
        justify-center
      >
        <div
          class="landing-carsoul-content-title"
          role="heading"
          aria-level="2"
          v-html="item.title"
        />
        <div
          class="landing-carsoul-content-date"
          role="text"
        >
          {{ item.date }}
        </div>
        <span class="sr-only">
          {{ item.title }} - {{ item.date }}
        </span>
        <v-divider
          role="presentation"
          aria-hidden="true"
        />
        <v-layout
          class="landing-carsoul-content-btns"
          align-center
          role="presentation"
        />
      </v-layout>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
import { mapActions } from "vuex";
import types from "@/constants/types";

export default {
  name: "Carousel",
  props: {
    items: {
        type: Array,
        default: () => [],
    },
  },
  methods: {
    ...mapActions({
      showPostDialog: types.UPDATE_COMPONENT_VISIBILITY
    }),

    toLink(link) {
      // track event
    //   this.$ga.event("carousel-posts", "open", link);
      // open link
      window.open(link);
    },
    showDialog(slug) {
      this.showPostDialog({
        dialog: {
            post: this.items.find(post => post.slug === slug) || {}
        }
      });
    }
  }
};
</script>

<style scoped>
/* Component-specific styles */
</style>
